/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">Plus de</MKTypography>
          <MKTypography variant="h2" color="info" sx={{ color: "#1d910eff" }} mb={4}>
            86+ clients satisfaits
          </MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 8 }} justifyContent="center">
          <Grid item xs={12} md={6} lg={12}>
            <div
              style={{
                width: "100%",
                padding: "24px",
                borderRadius: "12px",
                backgroundColor: "#f5f5f5",
                textAlign: "center",
              }}
            >
              <h3 style={{ color: "#1d910eff" }}>Contacts ANEMAR GROUPE</h3>
              <p>
                📍<strong>Adresse :</strong> Rond-point Anani, Port-Bouët, Abidjan, Côte d Ivoire
              </p>
              <p>
                📞<strong>Téléphone :</strong> +225 05 65 60 43 93 / +225 07 16 19 18 55
              </p>
              <p>
                💬<strong>WhatsApp :</strong> +225 07 16 19 18 55
              </p>
              <p>
                📧<strong>Email :</strong> groupeanemar21@gmail.com
              </p>
              <p>
                <strong>Réseaux sociaux :</strong> Anemar Groupe
              </p>
            </div>
          </Grid>
        </Grid>
        <Divider sx={{ my: 6 }} />
      </Container>
    </MKBox>
  );
}

export default Information;
